import React from 'react'
import { Badge } from 'reactstrap'

export const bookColumns = (layout, role) => [
	{
		name: 'ID',
		selector: (row) => row.id,
		sortable: true,
		width: '10%'
	},
	{
		name: 'Title',
		selector: (row) => row.title || '',
		sortable: true,
		width: '28%',
		cell: (row) => <div className="text-truncate">{row.title || 'N/A'}</div>
	},
	{
		name: 'Author',
		selector: (row) => row.author || '',
		sortable: true,
		width: '27%',
		cell: (row) => <div className="text-truncate">{row.author || 'N/A'}</div>
	},
	{
		name: 'Status',
		selector: (row) => row.isActive,
		sortable: true,
		width: '10%',
		cell: (row) => <Badge color={row.isActive ? 'success' : 'danger'}>{row.isActive ? 'Active' : 'Inactive'}</Badge>
	},
	{
		name: 'Actions',
		selector: (row) => row.id,
		sortable: false,
		width: '25%',
		cell: (row) => (
			<div className="d-flex gap-2">
				<a href={`${process.env.PUBLIC_URL}/${role}/books/edit/${row.id}/${layout}`} className="btn btn-success btn-sm">
					<i className="fa fa-edit me-1"></i>
				</a>
				{row.onDelete && (
					<button className="btn btn-danger btn-sm" onClick={row.onDelete}>
						 <i className="fa fa-trash"></i>
					</button>
				)}
			</div>
		)
	}
]
